module.exports = __webpack_public_path__ + "static/pgnig-d4939f9d1b434bab65a08eee28221eea.png";